import React from 'react';
import { Route, Routes } from 'react-router-dom';
import DisplayDirectoryPage from '../pages/DisplayDirectoryPage';
import BranchDisplayPage from '../pages/BranchDisplayPage';

const AppRouteBoundary = ({ children }) => (
  <Routes>
    <Route path="/display" element={<DisplayDirectoryPage />} />
    <Route path="/branches/:branchId/display/:screenId" element={<BranchDisplayPage />} />
    <Route path="/branches/:branchId/display" element={<BranchDisplayPage />} />
    <Route path="/*" element={children} />
  </Routes>
);

export default AppRouteBoundary;
